"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var useTooltipProps = function useTooltipProps(tooltip, editConfigText, children) {
  return (0, _react.useMemo)(function () {
    if (tooltip === true) {
      return {
        title: editConfigText !== null && editConfigText !== void 0 ? editConfigText : children
      };
    }
    if (/*#__PURE__*/(0, _react.isValidElement)(tooltip)) {
      return {
        title: tooltip
      };
    }
    if (_typeof(tooltip) === 'object') {
      return Object.assign({
        title: editConfigText !== null && editConfigText !== void 0 ? editConfigText : children
      }, tooltip);
    }
    return {
      title: tooltip
    };
  }, [tooltip, editConfigText, children]);
};
var _default = exports["default"] = useTooltipProps;